module.exports = __webpack_public_path__ + "static/pemalex_logo_clientes_santapassion-13f41da9f5e25c58899266cdedc795ab.png";